module.exports = __webpack_public_path__ + "media/images/logo-1200-c9616dd6511e5c3bc1e684a3720e8aa8.jpg";